import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { accountsReviewProfileDetailsApi } from "../../apis";
import AccountDetailsAction from "../../Components/AccountDetailsAction/AccountDetailsAction";
import PageTitle from "../../Components/UI/PageTitle";
import { transformKeys } from "../../_helper.js";
import AccountDetailsProfile from "../../Components/AccountDetailsAction/AccountDetailsProfile.jsx";
import Loader from "../../Components/Loader.jsx";
import ClientNotesHistory from "../../Components/ClientNotesHistory.jsx";
import { CLIENT_ACCOUNT_REVIEW_ID } from "../../constants/globals.js";
import ErrorAnimationComponent from "../../assets/lottie/ErrorAnimation/ErrorAnimationComponent.jsx";
const AccountReviewDetails = () => {
  const [profileData, setProfileData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const { clientId } = useParams();
  useEffect(() => {
    setIsLoading(true);
    accountsReviewProfileDetailsApi(clientId)
      .then((response) => {
        setProfileData(response.data.data);
      })
      .catch((error) => {
        setError(error.message || "An error occurred while fetching data");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [clientId]);

  const personalData = profileData?.personalData || {};
  const creationData = profileData?.creationData || {};
  const clientAccountReviewHistoryTable =
    profileData?.clientAccountReviewHistoryTable;

  const handlePesonalData = {
    ...transformKeys(personalData),
    client_gender:
      personalData?.clientGender == null
        ? "-"
        : parseInt(personalData?.clientGender) === 1
        ? "Male"
        : "Female",
  };
  const creationDataProfile = transformKeys(creationData);
  const {
    identification_pic_back,
    identification_pic_front,
    ...profilePersonalData
  } = handlePesonalData;

  if (isLoading) return <Loader />;
  if (error) return <ErrorAnimationComponent message={error} />;

  if (!profileData && !isLoading)
    return <div className="tw-text-center">No profile data available</div>;

  return (
    <>
      <PageTitle
        title="Account Review Details"
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          { title: "accounts review", link: "/accounts-review" },
          { title: "account Details", link: "/accounts-review" },
        ]}
      />
      <div className="tw-flex tw-flex-col tw-gap-4">
        <AccountDetailsProfile
          title="Personal Data"
          data={profilePersonalData || {}}
          img={""}
          identificationPicFront={identification_pic_front}
          identificationPicBack={identification_pic_back}
        />
        <AccountDetailsProfile
          title="Creation Data"
          data={creationDataProfile || {}}
        />
        <ClientNotesHistory
          notesHistory={clientAccountReviewHistoryTable || []}
        />
        {!(
          profileData?.clientAccountReviewId ==
          CLIENT_ACCOUNT_REVIEW_ID.CONFIRMED
        ) && <AccountDetailsAction />}
      </div>
    </>
  );
};

export default AccountReviewDetails;
